var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.438,
    height: 136.688,
    viewBox: "0 0 59.438 136.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3518",
    "data-name": "Path 3518",
    d: "M75.094,0H48V-104.437L15.656-94.406v-22.031l56.531-20.25h2.906Z",
    transform: "translate(-15.656 136.688)",
    fill: "#f37320",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.6f78da35eca23b721a724a59a40865d1.svg";
export { ForwardRef as ReactComponent };